import logo from 'assets/logo2.svg';
import { Link } from 'react-router-dom';
import { useDarkMode } from 'hooks/useDarkMode';

export const Logo = () => {
  const { isDarkMode } = useDarkMode();

  return (
    <Link className="flex items-center text-white" to="./">
      <img className="h-6 w-auto" src={logo} alt="Workflow" />
    </Link>
  );
};
